/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_2Inputs */

const en_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revealing your current salary too early`)
};

const de_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein aktuelles Gehalt zu früh preisgeben`)
};

const fr_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révéler ton salaire actuel trop tôt`)
};

const es_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar su salario actual demasiado pronto`)
};

const it_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivelare il tuo stipendio attuale troppo presto`)
};

const nl_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je huidige salaris te vroeg onthullen`)
};

const pl_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbyt wczesne ujawnianie obecnego wynagrodzenia`)
};

const fi_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyisen palkan paljastaminen liian aikaisin`)
};

const da_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At afsløre din nuværende løn for tidligt`)
};

const sv_salary_negotiate_mistake_2 = /** @type {(inputs: Salary_Negotiate_Mistake_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att avslöja din nuvarande lön för tidigt`)
};

/**
* | output |
* | --- |
* | "Revealing your current salary too early" |
*
* @param {Salary_Negotiate_Mistake_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_2 = /** @type {((inputs?: Salary_Negotiate_Mistake_2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_2(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_2(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_2(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_2(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_2(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_2(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_2(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_2(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_2(inputs)
	return en_salary_negotiate_mistake_2(inputs)
});